import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome';
import { faUnlink } from '@fortawesome/free-solid-svg-icons';

const PhotoContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  min-height: 20vh;
  position: relative;
  overflow: hidden;
  width: ${props => (props.fixed && '100px')};
  padding: 5px;

  div {
    position: absolute;
    padding: 0.5rem;
    background: var(--color-lighter);
    background: color-mix(in srgb, var(--color-lighter), transparent 30%);
    cursor: pointer;

    svg {
      color: var(--color-primary);
    }
  }

  img {
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
  }
`;

const Photo = ({ src, handleDelete, fixed = false, alt = 'Student' }) => {
  return (
    <PhotoContainer fixed={fixed}>
      <div onClick={handleDelete}>
        <FAIcon icon={faUnlink} />
      </div>
      <img src={src} alt={alt} />
    </PhotoContainer>
  );
};

export default Photo;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Student/Photo.jsx